import { useEffect, useState } from "react";
import API from "../api";
import { FilePicker } from "@capawesome/capacitor-file-picker";


function Bibliotheque() {
  const [planches, setPlanches] = useState([]);
  const [filter, setFilter] = useState("tous");
  const [title, setTitle] = useState("");
  const [grade, setGrade] = useState("apprenti");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isAdmin = user.role === "admin";

  useEffect(() => {
    fetchPlanches();
  }, []);

  const fetchPlanches = async () => {
    try {
      const res = await API.get("/planches");
      setPlanches(res.data);
    } catch (err) {
      console.error("Erreur planches:", err);
    }
  };

  const pickPdfFile = async () => {
    try {
      const result = await FilePicker.pickFiles({
        types: ["application/pdf"],
        multiple: false,
        readData: true,
      });

      const picked = result.files?.[0];

      if (!picked?.data) {
        alert("Impossible de lire le PDF");
        return;
      }

      const byteCharacters = atob(picked.data);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const blob = new Blob([new Uint8Array(byteNumbers)], {
        type: picked.mimeType || "application/pdf",
      });

      const selectedFile = new File(
        [blob],
        picked.name || "planche.pdf",
        {
          type: picked.mimeType || "application/pdf",
        }
      );

      setFile(selectedFile);
    } catch (err) {
      console.error(err);
      alert("Impossible de choisir le fichier PDF");
    }
  };

  const uploadPlanche = async () => {
    if (!title.trim()) {
      alert("Titre obligatoire");
      return;
    }

    if (!file) {
      alert("Fichier PDF obligatoire");
      return;
    }

    const formData = new FormData();

    formData.append("title", title.trim());
    formData.append("grade", grade);
    formData.append("pdf", file);

    try {
      setLoading(true);

      await API.post("/planches", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setTitle("");
      setGrade("apprenti");
      setFile(null);

      await fetchPlanches();

      alert("Document ajoutée ✅");
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Erreur upload");
    } finally {
      setLoading(false);
    }
  };

  const deletePlanche = async (id) => {
    if (!window.confirm("Supprimer cette planche ?")) {
      return;
    }

    try {
      await API.delete(`/planches/${id}`);
      await fetchPlanches();
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Erreur suppression");
    }
  };

 const openPdf = async (url) => {
  try {
    if (!url) {
      alert("Fichier introuvable");
      return;
    }

    const finalUrl = url.startsWith("http")
      ? url
      : `https://api.joss-serveur.duckdns.org${url}`;

    const isIOSPWA =
      window.navigator.standalone === true;

    if (isIOSPWA) {
      window.location.href = finalUrl;
      return;
    }
window.open(finalUrl, "_blank");
    } catch (err) {
      console.error(err);
      alert("Impossible d'ouvrir le PDF");
    }
  };

  const formatGrade = (g) => {
  if (g === "maitre") return "Membre niveau 3";
  if (g === "compagnon") return "Membre niveau 2";
  return "Membre niveau 1";
};

  const filteredPlanches = planches.filter((p) => {
  const matchesGrade =
    filter === "tous" || p.grade === filter;

  const matchesSearch =
    p.title
      ?.toLowerCase()
      .includes(search.toLowerCase());

  return matchesGrade && matchesSearch;
});

  return (
    <div style={styles.page}>

      <div style={styles.content}>
        <div style={styles.header}>
          <div>
            <div style={styles.kicker}>Bibliothèque</div>

            <h1 style={styles.title}>Bibliothèque</h1>

            <div style={styles.subtitle}>
              Documents, ressources et archives
            </div>
          </div>
        </div>

        {isAdmin && (
          <div style={styles.uploadBox}>
            <div style={styles.uploadTitle}>
              Ajouter un document
            </div>

            <input
              style={styles.input}
              type="text"
              placeholder="Titre du document"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />

            <select
              style={styles.input}
              value={grade}
              onChange={(e) => setGrade(e.target.value)}
            >
              <option value="apprenti">Membre niveau 1</option>
              <option value="compagnon">Membre niveau 2</option>
              <option value="maitre">Membre niveau 3</option>
            </select>

            <button
              type="button"
              style={styles.fileButton}
              onClick={pickPdfFile}
              disabled={loading}
            >
              {file
                ? `📄 ${file.name}`
                : "Choisir un fichier PDF"}
            </button>

            <button
              type="button"
              style={styles.uploadButton}
              onClick={uploadPlanche}
              disabled={loading}
            >
              {loading
                ? "Envoi..."
                : "Ajouter le document"}
            </button>
          </div>
        )}

        <div style={styles.filters}>
          {["tous", "apprenti", "compagnon", "maitre"].map((f) => (
            <button
              type="button"
              key={f}
              onClick={() => setFilter(f)}
              style={{
                ...styles.filterButton,
                ...(filter === f
                  ? styles.filterActive
                  : {}),
              }}
            >
              {f === "tous"
                ? "Tous"
                : formatGrade(f)}
            </button>
          ))}
        </div>

        <div style={styles.searchBox}>
  <span style={styles.searchIcon}>🔎</span>

  <input
    type="text"
    placeholder="Rechercher un document..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
    style={styles.searchInput}
  />

  {search && (
    <button
      type="button"
      onClick={() => setSearch("")}
      style={styles.clearSearch}
    >
      ×
    </button>
  )}
</div>

        {filteredPlanches.length === 0 && (
          <div style={styles.empty}>
            Aucun document disponible
          </div>
        )}

        <div style={styles.list}>
          {filteredPlanches.map((p) => (
            <div key={p.id} style={styles.card}>
              <div style={styles.cardTop}>
                <div style={styles.docIcon}>📚</div>

                <div style={styles.cardText}>
                  <h3 style={styles.cardTitle}>
                    {p.title}
                  </h3>

                  <div style={styles.metaRow}>
                    <span style={styles.gradeBadge}>
                      {formatGrade(p.grade)}
                    </span>

                    <span style={styles.pdfInfo}>
                      PDF
                    </span>
                  </div>
                </div>
              </div>

              <div
  style={{
    ...styles.actions,
    gridTemplateColumns: isAdmin
      ? "1fr 1fr 42px"
      : "1fr 1fr",
  }}
>
                <button
                  type="button"
                  style={styles.readButton}
                  onClick={() => openPdf(p.file_url)}
                >
                  Lire
                </button>

                <a
                  href={p.file_url}
                  download
                  style={styles.downloadButton}
                >
                  Télécharger
                </a>

                {isAdmin && (
                  <button
                    type="button"
                    style={styles.deleteButton}
                    onClick={() => deletePlanche(p.id)}
                  >
                    ×
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
const olive = "#8FAE5D";
const blue = "#6E8FB7";


const styles = {
  page: {
    minHeight: "100vh",
    position: "relative",
    overflowX: "hidden",
    background: "linear-gradient(180deg, #F4F0FA 0%, #E6DDF4 100%)",
    color: "#3B3450",
    backgroundSize: "cover",
    backgroundPosition: "center top",
    fontFamily: "Arial, sans-serif",
  },


  content: {
    position: "relative",
    zIndex: 1,
    padding: "24px 18px 125px",
  },

  header: {
    marginBottom: "18px",
  },

  kicker: {
    color: olive,
    fontSize: "16px",
    fontWeight: "900",
  },

  title: {
    margin: 0,
    color: "#3B3450",
    fontSize: "42px",
    lineHeight: "44px",
    fontWeight: "900",
    letterSpacing: "-1px",
  },

  subtitle: {
    marginTop: "6px",
    color: "#7B6F8F",
    fontSize: "17px",
  },

  uploadBox: {
  marginBottom: "18px",
  padding: "12px",
  marginTop: "10px",
  borderRadius: "20px",
  background: "rgba(255,255,255,0.85)",
  border: "1px solid rgba(143,174,93,0.20)",
  backdropFilter: "blur(10px)",
},

  uploadTitle: {
    color: olive,
    fontSize: "18px",
    fontWeight: "900",
    marginBottom: "12px",
  },

  input: {
    width: "100%",
    padding: "13px",
    marginBottom: "10px",
    borderRadius: "13px",
    border: "1px solid rgba(214,181,109,0.28)",
    background: "rgba(255,255,255,0.08)",
    color: "#3B3450",
    fontSize: "15px",
    boxSizing: "border-box",
    outline: "none",
  },

  fileButton: {
    width: "100%",
    padding: "14px",
    marginBottom: "12px",
    borderRadius: "14px",
    border: "1px solid rgba(214,181,109,0.45)",
    background: "rgba(255,255,255,0.85)",
    color: "#3B3450",
    fontSize: "15px",
    fontWeight: "900",
    textAlign: "center",
  },

  uploadButton: {
    width: "100%",
    padding: "14px",
    borderRadius: "14px",
    border: "none",
    background: olive,
    color: "#060606",
    fontSize: "15px",
    fontWeight: "900",
  },

  filters: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "8px",
    marginBottom: "18px",
  },

  filterButton: {
    padding: "10px 6px",
    borderRadius: "14px",
    border: "1px solid rgba(214,181,109,0.26)",
    background: "rgba(255,255,255,0.85)",
    color: "#7B6F8F",
    fontSize: "12px",
    fontWeight: "900",
  },

  filterActive: {
    background: olive,
    color: "#050505",
    border: "1px solid rgba(255,255,255,0.1)",
  },

  searchBox: {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "12px 14px",
  marginBottom: "18px",
  borderRadius: "18px",
  background: "rgba(255,255,255,0.85)",
  border: "1px solid rgba(143,174,93,0.20)",
  backdropFilter: "blur(10px)",
},

searchIcon: {
  fontSize: "18px",
  color: olive,
},

searchInput: {
  flex: 1,
  background: "transparent",
  border: "none",
  outline: "none",
  color: "#3B3450",
  fontSize: "15px",
},

clearSearch: {
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  border: "none",
  background: "rgba(255,255,255,0.12)",
  color: "#ffffff",
  fontSize: "18px",
  fontWeight: "900",
},

  empty: {
    padding: "24px",
    textAlign: "center",
    borderRadius: "20px",
    background: "rgba(1,6,13,0.68)",
    border: "1px solid rgba(214,181,109,0.28)",
    color: "rgba(255,255,255,0.7)",
  },

  list: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  card: {
    padding: "14px",
    borderRadius: "18px",
    background: "rgba(255,255,255,0.85)",
    border: "1px solid rgba(143,174,93,0.20)",
    boxShadow: "0 8px 20px rgba(110,143,183,0.12)",
    backdropFilter: "blur(12px)",
    transition: "0.2s ease",
  },

  cardTop: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "14px",
  },

  docIcon: {
    width: "54px",
    height: "54px",
    minWidth: "54px",
    borderRadius: "16px",
    border: "1px solid rgba(214,181,109,0.55)",
    background:
      "radial-gradient(circle at center, rgba(214,181,109,0.16), rgba(0,0,0,0.65))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "27px",
  },

  cardText: {
    flex: 1,
    minWidth: 0,
  },

  cardTitle: {
    margin: "0 0 7px",
    color: "#3B3450",
    fontSize: "20px",
    fontWeight: "900",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  metaRow: {
    display: "flex",
    alignItems: "center",
    gap: "9px",
  },

  gradeBadge: {
    padding: "5px 10px",
    borderRadius: "999px",
    border: "1px solid rgba(214,181,109,0.45)",
    background: "rgba(214,181,109,0.12)",
    color: olive,
    fontSize: "13px",
    fontWeight: "900",
  },

  pdfInfo: {
    color: "#7B6F8F",
    fontSize: "13px",
    fontWeight: "800",
  },

  actions: {
  display: "grid",
  gap: "8px",
},

  readButton: {
    height: "44px",
    borderRadius: "13px",
    border: "none",
    background: olive,
    color: "#050505",
    fontSize: "14px",
    fontWeight: "900",
  },

  downloadButton: {
    height: "44px",
    borderRadius: "13px",
    border: "1px solid rgba(214,181,109,0.28)",
    background: "rgba(0,0,0,0.32)",
    color: "#ffffff",
    fontSize: "13px",
    fontWeight: "900",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  deleteButton: {
    height: "44px",
    borderRadius: "13px",
    border: "1px solid rgba(255,90,90,0.22)",
background: "rgba(50,12,12,0.55)",
    color: "#ffffff",
    fontSize: "25px",
    fontWeight: "900",
  },
};

export default Bibliotheque;